import { type RouteLocationNormalizedGeneric } from "vue-router";

import { appInstance } from "shared/boot/app";

import { type ProductMenuKey } from "./useProductMenu";

export default function useProductRouting() {
  function doesMatchRoutePrefix(
    routePrefix: string,
    to?: RouteLocationNormalizedGeneric
  ) {
    const currentRoute = to || appInstance.config.globalProperties.$route;

    if (currentRoute.params?.product) {
      return currentRoute.params.product === routePrefix;
    }

    return currentRoute.matched.some(
      (matchedRoute) => matchedRoute.name === routePrefix
    );
  }

  function routeProductName(
    to?: RouteLocationNormalizedGeneric
  ): ProductMenuKey {
    if (doesMatchRoutePrefix("social", to)) {
      return "social";
    }

    if (doesMatchRoutePrefix("competitor-dashboard", to)) {
      return "competitor";
    }

    if (doesMatchRoutePrefix("crm", to)) {
      return "crm";
    }

    if (doesMatchRoutePrefix("outreach", to)) {
      return "outreach";
    }

    if (doesMatchRoutePrefix("csl", to)) {
      return "csl";
    }

    if (doesMatchRoutePrefix("dashboard", to)) {
      return "dashboard";
    }

    if (doesMatchRoutePrefix("insights", to)) {
      return "insights";
    }

    return "media";
  }

  return { routeProductName };
}
